import React from "react";
import Subheader from "../../blocks/sub-header/Subheader";
import Internet from "../../blocks/internet-section/Internet";
import Wifi from "../../blocks/wi-fi-section/Wifi";
import Phone from "../../blocks/phone-section/Phone";
import Video from "../../blocks/video-section/Video";
import Commercial from "../../blocks/comercial-offer/Commercial";
import CommercialList from "../../blocks/commercial/CommercialList";
import './Main.css';


export default function Main()
{
    return (
        <main className="main">
            <Subheader />
            <Internet />
            <Wifi />
            <Phone />
            <Video />
            <Commercial />
            <CommercialList />
        </main>
    )
}